import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { useSiteContent } from "@/context/SiteContentContext";

interface ProcessStep {
  numero: string;
  titulo: string;
  descripcion: string;
}

export default function Process() {
  const { sections } = useSiteContent();
  const content = sections.proceso || {};
  const steps = (content.steps as ProcessStep[]) || [];

  return (
    <section id="proceso" className="relative py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <SectionHeading
          eyebrow="Proceso de trabajo"
          title={String(content.title || "Un proceso claro, de la idea al lanzamiento.")}
        />

        <div className="mt-14 relative">
          <div className="absolute left-5 md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-primary-200 via-primary-300 to-accent-300 md:-translate-x-1/2" />

          <div className="space-y-8 md:space-y-0">
            {steps.map((step, i) => {
              const isLeft = i % 2 === 0;
              return (
                <div
                  key={`${step.numero}-${i}`}
                  className={`relative flex md:items-center ${
                    isLeft ? "md:justify-start" : "md:justify-end"
                  }`}
                >
                  <div className="absolute left-5 md:left-1/2 -translate-x-1/2 top-0 md:top-1/2 md:-translate-y-1/2 z-10">
                    <span className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50 border-2 border-primary-500 text-primary-600 font-bold text-sm shadow-[0_0_20px_oklch(var(--primary-500)/0.25)]">
                      {step.numero}
                    </span>
                  </div>

                  <Reveal
                    variant={isLeft ? "left" : "right"}
                    className={`w-full md:w-[calc(50%-3rem)] ${
                      isLeft ? "md:mr-auto pl-16 md:pl-0 md:pr-4" : "md:ml-auto pl-16 md:pl-4"
                    } ${i !== steps.length - 1 ? "pb-4" : ""}`}
                  >
                    <div className="rounded-2xl border border-background-200 bg-background-50 p-5 transition-all duration-300 hover:border-primary-200 hover:shadow-[0_12px_32px_rgba(30,60,120,0.07)]">
                      <h3 className="text-lg font-semibold text-foreground-950 flex items-center gap-2">
                        <span className="text-primary-500 font-bold">{step.numero}</span>
                        {step.titulo}
                      </h3>
                      <p className="mt-1.5 text-sm text-foreground-600">{step.descripcion}</p>
                    </div>
                  </Reveal>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}